export const CREATE_DOCUMENT_MODAL_CONFIG = {
  firstTitleKey: 'Where do you want to add Document(s)?',
  secondTitleKey: 'Add Document(s) to a Home',
  primaryButtonKey: 'Add Default Document(s)',
  secondaryButtonKey: 'Add Document(s) to a Home',
  createButtonKey: 'Upload Document(s)',
  routerLinkKey: 'documents'
};
